/**
 * 解除关系
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import {
  _change_affinity_modal,
  _get_user_affinity_info,
} from '../../../src/store/Action';
import './common.scss';
import * as Map from 'immutable';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';

class DeleteAffinity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      detail: {},
      otherUid: null,
      cancelOrderNo: null,
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinityDeleteModal);
    const props2 = Map.fromJS(this.props.base.affinityDeleteModal);

    if (!this.props.base.affinityDeleteModal) {
    } else if (this.props.base.affinityDeleteModal && !Map.is(props1, props2)) {
      if (
        this.props.base.affinityDeleteOtherUid ||
        this.props.base.affinityDeleteOrderNo
      )
        this.showModal({
          otherUid: this.props.base.affinityDeleteOtherUid,
          cancelOrderNo: this.props.base.affinityDeleteOrderNo,
        });
    }
  }
  showModal = ({ otherUid, cancelOrderNo }) => {
    this.setState(
      {
        otherUid,
        cancelOrderNo,
      },
      () => {
        this.getAffinityDeleteDetail();
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinityDeleteModal: false,
      affinityDeleteOtherUid: null,
      affinityDeleteOrderNo: null,
    });
  };

  //获取关系详情
  getAffinityDeleteDetail = () => {
    const { otherUid, cancelOrderNo } = this.state;
    let params = {
      otherUid,
      cancelOrderNo,
    };
    let url = '';
    if (cancelOrderNo) {
      url = '_get_affinity_delete_detail_msg';
    } else if (otherUid) {
      url = '_get_affinity_delete_detail';
    }
    HTTP[url](params).then((res) => {
      if (res.code == 200) {
        this.setState({
          detail: res.data,
          visible: true,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  //强制解除
  onForceDelete = () => {
    const { detail } = this.state;
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: (
        <span>
          强制解除关系需要消耗{detail?.forceCancelDiamondAmount}
          钻石，解除后你们的关系装扮和信物都将消失，确定解除吗？
        </span>
      ),
      className: 'daidai-confirm-style',
      okText: '确认',
      cancelText: '我再想想',
      centered: true,
      onOk: () => {
        this.onSubmit(true);
      },
    });
  };
  //协议解除
  onDelete = () => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: (
        <span>
          对方同意后，你们的关系装扮和信物都将消失，确定发出关系解除申请吗？
        </span>
      ),
      className: 'daidai-confirm-style',
      okText: '确认',
      cancelText: '我再想想',
      centered: true,
      onOk: () => {
        this.onSubmit(false);
      },
    });
  };

  //同意
  onAgree = () => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: (
        <span>解除关系后，你们的关系装扮和信物都将消失，确定解除吗？</span>
      ),
      className: 'daidai-confirm-style',
      okText: '确认',
      cancelText: '我再想想',
      centered: true,
      onOk: () => {
        this.onRejectOrAccept(true);
      },
    });
  };

  //bool: true强制解除，false协议解除
  onSubmit = (bool) => {
    const { detail } = this.state;
    let params = {
      receiveUid: detail?.otherUid,
      type: bool ? 1 : 0,
    };
    HTTP._get_affinity_delete(params).then((res) => {
      if (res.code == 200) {
        this.setState({ cancelOrderNo: res.data?.cancelOrderNo });
        this.getAffinityDeleteDetail();
        _get_user_affinity_info();
        if (bool) {
          Modal.info({
            title: '提示',
            icon: null,
            closable: true,
            content: <span>你们的关系已解除!</span>,
            className: 'daidai-confirm-style',
            okText: '我知道了',
            centered: true,
          });
        }
      } else {
        message.error(res.message);
      }
    });
  };

  //同意拒绝
  onRejectOrAccept = (bool) => {
    const { detail } = this.state;
    let params = {
      cancelOrderNo: detail?.cancelOrderNo,
      status: bool ? 90 : 60,
    };
    HTTP._get_affinity_delete_reject_or_accept(params).then((res) => {
      if (res.code == 200) {
        this.setState({ cancelOrderNo: res.data?.cancelOrderNo });
        this.getAffinityDeleteDetail();
        _get_user_affinity_info();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { loading, detail, visible } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1002}
          wrapClassName="daidai-modal-style has-top-border affinity-space bg0"
          centered={true}
          title={`解除关系`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <Scrollbar
              ref={(el) => (this.scrollElement = el)}
              className="my-scroll-bar"
              style={{ height: '620px' }}
            >
              <div className="affinity-space-box" style={{ padding: '0 28px' }}>
                <div className="affinity-space-top">
                  <div className="affinity-space-item">
                    <div className="affinity-space-avatar">
                      <img
                        src={Util.transImgUrl(detail?.searchAvatar, '100x100')}
                        alt=""
                      />
                    </div>
                    <div className="affinity-space-name">
                      {detail?.searchNickname}
                    </div>
                  </div>
                  <div
                    className={`affinity-space-line line-${detail?.relationConfig?.relationConfigId - 999}`}
                  ></div>
                  <div className="affinity-space-item">
                    <div className="affinity-space-avatar">
                      <img
                        src={Util.transImgUrl(detail?.otherAvatar, '100x100')}
                        alt=""
                      />
                    </div>
                    <div className="affinity-space-name">
                      {detail?.otherNickName}
                    </div>
                  </div>
                </div>
                <div className="affinity-space-text text-1">
                  <p>
                    成为
                    <span
                      style={{
                        color: detail?.relationConfig?.relationConfigCardStyle,
                      }}
                    >
                      {detail?.relationConfig?.relationConfigName}
                    </span>
                    已经<b>{detail?.daysBetween}</b>天
                  </p>
                </div>
                <div
                  className="affinity-space-card"
                  style={{
                    backgroundImage: `url(${Util.transImgUrl(detail?.relationConfig?.spaceSmallBackground)})`,
                  }}
                >
                  <div
                    className="affinity-space-card-level"
                    style={{
                      color: detail?.relationConfig?.relationConfigCardStyle,
                    }}
                  >
                    {detail?.relationConfig?.relationConfigName}LV
                    {detail?.level}
                  </div>
                  <div className="affinity-space-card-cover">
                    <img
                      src={Util.transImgUrl(
                        detail?.relationConfig?.relationConfigIcon,
                        '50x50'
                      )}
                      alt=""
                    />
                  </div>
                  <div className="affinity-space-card-value">
                    亲密值<span>{detail?.intimate}</span>
                  </div>
                </div>
                <div className="affinity-space-delete-text">
                  <p>
                    {detail?.viewContents?.map((item, index) => (
                      <span
                        className={`${item.needColor ? 'color' : ''}`}
                        key={index}
                      >
                        {item.content}
                      </span>
                    ))}
                  </p>
                </div>
                {detail?.status == 100 ? (
                  <div className="affinity-space-action">
                    <div
                      className="affinity-space-btn red"
                      onClick={this.onForceDelete}
                    >
                      <span>强制解除</span>
                    </div>
                    <div
                      className="affinity-space-btn yellow"
                      onClick={this.onDelete}
                    >
                      <span>协议解除</span>
                    </div>
                  </div>
                ) : detail?.resultType == 1 &&
                  detail?.status != 60 &&
                  detail?.status != 80 &&
                  detail?.status != 90 ? (
                  <div className="affinity-space-action">
                    <div
                      className="affinity-space-btn red"
                      onClick={() => this.onRejectOrAccept(false)}
                    >
                      <span>拒绝</span>
                    </div>
                    <div
                      className="affinity-space-btn yellow"
                      onClick={this.onAgree}
                    >
                      <span>同意</span>
                    </div>
                  </div>
                ) : detail?.resultType == 0 &&
                  detail?.status != 60 &&
                  detail?.status != 70 &&
                  detail?.status != 80 &&
                  detail?.status != 90 ? (
                  <div className="affinity-space-action">
                    <div className="affinity-space-btn default">
                      <span>解除申请已发出，等待对方同意</span>
                    </div>
                  </div>
                ) : null}
              </div>
            </Scrollbar>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(DeleteAffinity, { withRef: true })
);
